

export const GetThumbnail = async (url) => {
    var videoId = getYtVideoId(url);
    let thumbnailUrl = "";


    let hasThumbnail = await hasMaxResThumbnail(videoId);
    if(hasThumbnail){
        thumbnailUrl = 'https://img.youtube.com/vi/' + videoId + '/maxresdefault.jpg';
    }
    else{
        thumbnailUrl = 'https://img.youtube.com/vi/' + videoId + '/mqdefault.jpg';
    }

    return thumbnailUrl;
}

export const getYtVideoId = (url) => {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??(v\=)?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return match ? match[8] : false;
}

export const hasMaxResThumbnail = (id) => {
    return new Promise((resolve, reject) => {
        let img = new Image();
        img.src = "http://img.youtube.com/vi/" + id + "/maxresdefault.jpg";
        img.onload = function () {
            if (this.width === 120) {
                resolve(false);
            }
            else {
                resolve(true);
            }
        }
    })  
}